// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "buyer-responsive-" + ({2239: "ActionToast",2733: "NftSecondaryMarketModal",2944: "RecentlyViewed",5338: "NftPdpZoomModal",8756: "EthereumWallet",9289: "ModelViewer",}[chunkId] || chunkId) + ".571.0.0." + {2239: "a63929c931c4ab63",2733: "640934451929d8de",2944: "a9262155bc111b21",5233: "b7e7b7489ddf2a65",5338: "f15f679675ed185b",8756: "128ef1f570dc4d92",9289: "161d0e37b064fe2b",}[chunkId] + ".css"
}